import { GetSiteRitualsQuery } from 'data/__generated__';

import { isFirstTimeLowerThanSecond } from './dateTimes';

export function getRitualCalendarExtremeHours(rituals: GetSiteRitualsQuery['siteRituals']): {
    minHour: string;
    maxHour: string;
} {
    let minHour = rituals[0].timeWindow.start;
    let maxHour = rituals[0].timeWindow.end;

    rituals.forEach((ritual) => {
        const {
            timeWindow: { start, end },
        } = ritual;
        if (isFirstTimeLowerThanSecond(start, minHour)) {
            minHour = start;
        }
        if (isFirstTimeLowerThanSecond(maxHour, end)) {
            maxHour = end;
        }
    });

    return { minHour, maxHour };
}
